module.exports = __webpack_public_path__ + "img/symbol_5.3831ee53.png";